<template>
    <div class="user-portfolio-contacts">
        <div class="user-portfolio-contacts__title">Контакты</div>
        <div class="user-portfolio-contacts__block" v-if="phone">
            <img src="@/assets/images/portfolio/phone.svg" alt=""/>
            <span v-html="phone" />
        </div>
        <div class="user-portfolio-contacts__block" v-if="email">
            <img src="@/assets/images/portfolio/email.svg" alt=""/>
            <span v-html="email" />
        </div>
        <div class="user-portfolio-contacts__block" v-if="!phone && !email">Нет данных</div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getHighlightGroupsKeywordsSet, highlightStrKeywords} from "@/tools/graphQueryHelpers";

export default {
    props: {
        highlights: {
            type: Object,
            required: false,
            default: () => null,
        },
    },

    computed: {
        ...mapGetters('newUsers', [
            'getUser',
        ]),

        highlightKeywords() {
            return getHighlightGroupsKeywordsSet(this.highlights, [
                'profile.email',
                'profile.registration_email',
                'profile.phone_number',
                'profile.registration_phone_number',
            ]);
        },

        phone() {
            return highlightStrKeywords(
                this.getUser.tel || this.getUser.regTel || '',
                this.highlightKeywords
            );
        },

        email() {
            return highlightStrKeywords(
                this.getUser.email || this.getUser.regEmail || '',
                this.highlightKeywords
            );
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-contacts {
    display: flex;
    flex-direction: column;
    gap: mrem(16);

    @include on-desktop {
        gap: rem(16);
    }

    &__title {
        font-weight: 700;
        font-size: mrem(18);
        line-height: mrem(24);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
        }
    }

    &__block {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: mrem(10);
        word-break: break-all;

        font-weight: 600;

        @include on-desktop {
            gap: rem(10);
        }
    }

    &__socials {
        margin-top: mrem(24);

        @include on-desktop {
            margin-top: rem(24);
        }
    }
}

</style>
